import { useEffect, useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { loadRuntimeConfig, type RuntimeConfig } from './runtimeConfig';
import { RuntimeConfigContext } from './RuntimeConfigContext';
import { CenterCard } from '@/components/CenterCard';

export function ConfigProvider({ children }: { children: ReactNode }) {
    const { t } = useTranslation();
    const [config, setConfig] = useState<RuntimeConfig | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        loadRuntimeConfig()
            .then(setConfig)
            .catch((err: Error) => setError(err.message));
    }, []);

    if (error) {
        return (
            <CenterCard title={t('shell.configBoot.errorTitle')} showSpinner={false}>
                <p className="portal-callback-error">{error}</p>
            </CenterCard>
        );
    }
    if (!config) {
        return <CenterCard title={t('shell.configBoot.loadingTitle')} />;
    }
    return <RuntimeConfigContext.Provider value={config}>{children}</RuntimeConfigContext.Provider>;
}
